module.exports = __webpack_public_path__ + "img/blog8.802f86f5.jpeg";